module.exports = __webpack_public_path__ + "img/icon-type-excel.8e54c21d.svg";